import React from "react";

import styled from "styled-components";
import Map from "Page/common/Map";

export default function MapDiv() {
  const MapDiv = styled.div`
    width: 100%;
    padding: 80px 50px;

    display: flex;
    flex-direction: column;
    gap: 30px;
  `;

  const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;

    & > div:first-child {
      font-size: 28px;
      font-weight: bold;
    }

    & > div:nth-child(2) {
      height: 1px;
      width: 80px;
      border-bottom: solid 2px var(--color-blueblack);
    }
  `;

  const ContentDiv = styled.div`
    width: 100%;

    display: flex;
    flex-direction: row;
  `;

  const MapContainer = styled.div`
    width: 60%;
    height: 300px;
  `;

  const InfoContainer = styled.div`
    padding: 0 30px;

    flex-grow: 1;
    display: flex;
    flex-direction: column;
    gap: 40px;
    & > div {
      width: 100%;

      display: flex;
      flex-direction: column;
      gap: 20px;

      & > div:first-child {
        font-size: var(--font-size-title);
        color: var(--color-blue);
        font-weight: bold;
      }

      & > div:nth-child(2) {
        font-size: var(--font-size-content);

        display: flex;
        flex-direction: column;
        gap: 10px;
      }
    }
  `;

  return (
    <MapDiv>
      <TitleContainer>
        <div>찾아오시는 길</div>
        <div />
      </TitleContainer>
      <ContentDiv>
        <MapContainer>
          <Map />
        </MapContainer>
        <InfoContainer>
          <div>
            <div>[자차]</div>
            <div>
              <p>전남대학교 캠퍼스 내 또는 외부 주차</p>
              <p>(캠퍼스 주차요금 30분 무료 / 10분당 1000원)</p>
            </div>
          </div>

          <div>
            <div>[대중교통-버스]</div>
            <div>
              <p>대신파크 정류장 19, 54, 28, 38 등</p>
            </div>
          </div>
        </InfoContainer>
      </ContentDiv>
    </MapDiv>
  );
}
